import script from "./Verse.vue?vue&type=script&setup=true&lang=js"
export * from "./Verse.vue?vue&type=script&setup=true&lang=js"

import "./Verse.vue?vue&type=style&index=0&id=3439cfb6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3439cfb6"]])

export default __exports__